import { Error, Login, ProtectedRoute } from './pages/'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import {
  AddInformationItem,
  AllInformationItems,
  Profile,
  SharedLayout,
  DiagramsMonthlyProgression,
  DiagramsAnnualComparison,
  DiagramsMonthlyComparison
} from './pages/dashboard'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <ProtectedRoute>
            <SharedLayout />
          </ProtectedRoute>
        }>
          <Route index element={<DiagramsMonthlyProgression />} />
          <Route path="all-informationItems" element={<AllInformationItems />} />
          <Route path="monthly-comparison" element={<DiagramsMonthlyComparison />} />
          <Route path="annual-comparison" element={<DiagramsAnnualComparison />} />
          <Route path="add-informationItem" element={<AddInformationItem />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
